import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppComponent } from './app.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { ClientsModule } from './modules/clients/clients.module';
import { ChatModule } from './modules/chat/chat.module';
import { TimesheetComponent } from './modules/timesheet/timesheet/timesheet.component';
import { FcmService } from './core/services/fcm/fcm.service';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire';
import { AsyncPipe } from '@angular/common';
import { environment } from 'src/environments/environment';

import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar-EG';
import { PrintModule } from './modules/print/print.module';
registerLocaleData(localeAr);



@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    NgxSpinnerModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
    }),
    CoreModule,
    SharedModule,
    AuthenticationModule,
    DashboardModule,
    ClientsModule,
    ChatModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    PrintModule
  ],
  declarations: [AppComponent, TimesheetComponent],
  providers: [FcmService, AsyncPipe, { provide: LOCALE_ID, useValue: 'ar-EG' },],
  bootstrap: [AppComponent]
})
export class AppModule { }
